import { Address, erc20Abi } from 'viem';

export interface MakeApproveTxArgs {
  token: Address;
  spender?: string;
  amount: bigint;
}

export const makeApproveTx = ({ token, spender, amount }: MakeApproveTxArgs) => ({
  address: token,
  abi: erc20Abi,
  functionName: 'approve',
  args: spender && amount ? [spender, amount] : undefined,
});
